export default function formatNumber(number: number) {
  if (number === null || number === undefined) {
    return '-';
  } else {
    const numberString = new Intl.NumberFormat('vi-VN').format(number);
    return `${numberString}`;
  }
}
